import { Ditto } from '@ow/ditto-core'
import * as DtDefault from '../fields/default'
import * as DtText from '../fields/text'
import * as DtArray from '../fields/array'
import * as DtBatchText from '../fields/batchText'
import * as DtRichText from '../fields/richText'
import * as DtNumber from '../fields/number'
import * as DtDropSelect from '../fields/dropselect'
import * as DtTree from '../fields/tree'
import * as DtArea from '../fields/area'
import * as DtStandard from '../fields/standard'
import * as DtMedia from '../fields/media'
import * as DtAttachment from '../fields/attachment'
import * as DtDatetime from '../fields/datetime'
import * as DtOrg from '../fields/org'
import * as DtUser from '../fields/user'
import * as DtGeolocation from '../fields/geolocation'
import * as DtGis from '../fields/gis'
import * as DtRef from '../fields/ref'
import * as DtProduct from '../fields/product'

export const ditto = new Ditto()

ditto.registeWidget('default', { render: DtDefault.Render })
ditto.registeWidget('text', {
  render: DtText.Render,
  validation: DtText.validation,
})
ditto.registeWidget('locationWithText', {
  render: DtText.Render,
})
ditto.registeWidget('array', {
  render: DtArray.Render,
  validation: DtArray.validation,
})
ditto.registeWidget('batchText', {
  render: DtBatchText.Render,
  validation: DtBatchText.validation,
})
ditto.registeWidget('richText', {
  render: DtRichText.Render,
  validation: DtRichText.validation,
})
ditto.registeWidget('number', {
  render: DtNumber.Render,
  validation: DtNumber.validation,
})
ditto.registeWidget('dropSelect', {
  render: DtDropSelect.Render,
  validation: DtDropSelect.validation,
})
ditto.registeWidget('tree', {
  render: DtTree.Render,
})
ditto.registeWidget('media', {
  render: DtMedia.Render,
  validation: DtMedia.validation,
})
ditto.registeWidget('attachment', {
  render: DtAttachment.Render,
  validation: DtMedia.validation,
})
ditto.registeWidget('datetime', {
  render: DtDatetime.Render,
  validation: DtDatetime.validation,
})
ditto.registeWidget('org', {
  render: DtOrg.Render,
  validation: DtOrg.validation,
})
ditto.registeWidget('orgMultiple', {
  render: DtOrg.Render,
  validation: DtOrg.validation,
})
ditto.registeWidget('user', {
  render: DtUser.Render,
  validation: DtUser.validation,
})
ditto.registeWidget('userMultiple', {
  render: DtUser.Render,
  validation: DtUser.validation,
})
ditto.registeWidget('area', {
  render: DtArea.Render,
  validation: DtArea.validation,
})
ditto.registeWidget('standard', {
  render: DtStandard.Render,
  validation: DtStandard.validation,
})
ditto.registeWidget('geolocation', {
  render: DtGeolocation.Render,
  validation: DtGeolocation.validation,
})
ditto.registeWidget('gis', {
  render: DtGis.Render,
})
ditto.registeWidget('ref', {
  render: DtRef.Render,
  validation: DtRef.validation,
})
ditto.registeWidget('product', {
  render: DtProduct.Render,
})

export default ditto
